import {
  Module,
  VuexModule,
  Mutation,
  getModule,
} from 'vuex-module-decorators';
import store from '@/store';

@Module({
  dynamic: true,
  store,
  name: 'snackbarState',
  namespaced: true,
})
export class SnackbarStateService extends VuexModule {
  error: any;

  message: any;

  @Mutation
  public showError(error: any) {
    this.error = error;
  }

  @Mutation
  public handleHttpError(error: any) {
    this.error = error;
  }

  @Mutation
  public showSuccess(message: string) {
    this.message = message;
  }
}

const SnackbarService = (() => getModule(SnackbarStateService))();

export default SnackbarService;
export { SnackbarService as VbSnackbarService };
